import { FC } from 'react';

const NotFoundPage: FC = () => {
  return (
    <div>
      <h1 className="text-center font-bold text-3xl mt-20 text-indigo-500">404 - Not Found</h1>
    </div>
  );
};

export default NotFoundPage;
